import { render } from "./Diamonds.vue?vue&type=template&id=15a5df05"
import script from "./Diamonds.vue?vue&type=script&lang=js"
export * from "./Diamonds.vue?vue&type=script&lang=js"

import "./Diamonds.vue?vue&type=style&index=0&id=15a5df05&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__